// extracted by mini-css-extract-plugin
export default {"buttonContainer":"LegalCapacity_buttonContainer__UY-XS"};